<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  header="Update Group"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '540px' }"
  [draggable]="false"
  [resizable]="false">
  <form [formGroup]="form">
    <div class="dialog-body gray-bg-rounded bdr-rounded">
      <div class="form-group has-float-label mb-3">
        <label class="form-label"
          >Group Name<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          type="text"
          class="form-control"
          formControlName="groupName"
          maxlength="256"
          placeholder="Enter group name" />
        @if (
          form.controls.groupName.touched && form.controls.groupName.invalid
        ) {
          <span class="error-msg">
            @if (form.controls.groupName.errors?.["required"]) {
              Group Name is required.
            } @else if (form.controls.groupName.errors?.["maxlength"]) {
              Group Name cannot exceed 256 characters.
            } @else if (form.controls.groupName.errors?.["pattern"]) {
              Group Name contains invalid characters.
            }
          </span>
        }
      </div>

      <div class="form-group has-float-label mb-3">
        <label class="form-label">Description</label>
        <textarea
          pTextarea
          class="form-control"
          formControlName="description"
          maxlength="256"
          placeholder="Enter group description"
          rows="3">
        </textarea>
        @if (
          form.controls.description.touched &&
          form.controls.description.errors?.["maxlength"]
        ) {
          <span class="error-msg">
            Description cannot exceed 256 characters.
          </span>
        }
      </div>

      <div class="form-group has-float-label mb-3">
        <label class="form-label">Assign Users</label>
        <p-autoComplete
          formControlName="userSearch"
          [suggestions]="suggestions"
          (completeMethod)="searchUsers($event)"
          (onSelect)="onUserSelect($event)"
          (keydown.enter)="addUser()"
          field="email"
          appendTo="body"
          placeholder="Search users to add..."
          styleClass="w-100">
          <ng-template let-user pTemplate="item">
            <div class="d-flex flex-column">
              <span>{{ user.displayName }}</span>
              <small class="text-muted">{{ user.email }}</small>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>

      @if (usersLoading) {
        <div
          class="d-flex align-items-center gap-2 mt-1 mb-2 text-muted users-loading-text">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading assigned users...</span>
        </div>
      }

      <div
        class="assigned-users-list"
        *ngIf="!usersLoading && assignedUsers.length > 0">
        <div
          class="user-item d-flex align-items-center justify-content-between"
          *ngFor="let user of assignedUsers">
          <div class="d-flex align-items-center gap-2">
            <i class="pi pi-user"></i>
            <span
              [pTooltip]="user"
              tooltipPosition="top"
              tooltipStyleClass="group-modal-tooltip"
              >{{ user }}</span
            >
          </div>
          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="resend-btn"
              pTooltip="Resend invitation email"
              tooltipPosition="top"
              tooltipStyleClass="group-modal-tooltip"
              [disabled]="saving || isResending(user)"
              (click)="resendInvitation(user)">
              <i
                class="pi"
                [ngClass]="
                  isResending(user) ? 'pi-spin pi-spinner' : 'pi-envelope'
                "></i>
            </button>
            <button
              type="button"
              class="remove-btn"
              [disabled]="saving"
              (click)="removeUser(user)">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end gap-2 border-0 modal-footer-actions">
        <p-button
          label="Cancel"
          variant="outlined"
          severity="secondary"
          (click)="closeModal()" />
        <p-button
          label="Update"
          (click)="updateGroup()"
          [loading]="saving"
          [disabled]="form.invalid || saving" />
      </div>
    </div>
  </form>
</p-dialog>
